import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettings1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8164 18.3632L16.4983 21.0446C16.7907 21.343 17.1391 21.5809 17.5236 21.7447C17.908 21.9085 18.321 21.995 18.7389 21.9992C19.1568 22.0035 19.5714 21.9253 19.9591 21.7693C20.3467 21.6133 20.6999 21.3825 20.9983 21.09L21.0447 21.0437C21.6472 20.453 21.9903 19.6473 21.9986 18.8037C22.007 17.9602 21.6799 17.1478 21.0892 16.5454L21.0429 16.499L19.271 14.7275",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5361 9.15159L4.91055 2.52734L2.59961 4.83783L9.07062 11.3076",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.7059 5.56712L18.9077 8.35298L15.6349 5.10266L18.435 2.3159C17.7891 2.036 17.0785 1.93945 16.3813 2.03686C15.0877 2.14795 13.885 2.74773 13.0181 3.71411C12.1512 4.68049 11.6851 5.94084 11.7149 7.23863C11.7094 7.74913 11.8058 8.25559 11.9985 8.72836L3.03928 16.6206C2.42414 17.1691 2.05213 17.9395 2.00507 18.7623C1.95802 19.5851 2.23978 20.3928 2.78837 21.0079C2.80928 21.0325 2.8311 21.0552 2.85292 21.0788C3.1243 21.3622 3.44886 21.5894 3.80806 21.7473C4.16727 21.9052 4.55407 21.9909 4.94639 21.9993C5.3387 22.0078 5.72884 21.9388 6.0945 21.7965C6.46017 21.6541 6.79421 21.4412 7.07753 21.1697C7.16838 21.0843 7.25371 20.9933 7.33299 20.897L15.2658 11.9805C16.1136 12.2294 17.0054 12.2915 17.8795 12.1623C18.8006 11.9719 19.6523 11.534 20.3429 10.8956C21.0335 10.2572 21.5368 9.4425 21.7987 8.53931C22.0959 7.56539 22.0633 6.52063 21.7059 5.56712Z",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSettings1;
